import PropTypes from 'prop-types';
import { Button } from 'antd';
import { FormattedMessage } from 'react-intl';
import ModalDlg from 'components/Basic/ModalDlg';

const CloseModalEditOffer = ({ isOpenModal, onCancel, onClose }) => {
  return (
    <ModalDlg className="save_as_draft_modal" visible={isOpenModal} width={434} handleCancel={onCancel} isCenter>
      <div className="header">
        <h3>
          <FormattedMessage id="Close the offer" />
        </h3>
        <p className="description">
          <FormattedMessage id="All modified information will be deleted" />
        </p>
      </div>
      <div className="footer">
        <div className="btn_wrapper">
          <p onClick={onCancel}>
            <FormattedMessage id="Cancel" />
          </p>
          <Button className="save_button" onClick={onClose}>
            <FormattedMessage id="Close" />
          </Button>
        </div>
      </div>
    </ModalDlg>
  );
};

CloseModalEditOffer.defaultProps = {
  isOpenModal: false,
};

export default CloseModalEditOffer;
